import SmartySDK from 'smartystreets-javascript-sdk';

export type SmartyAutocompleteInputT = {
  street: string;
};

export type SmartyUsAutocompleteClientT = ReturnType<typeof SmartySDK.core.buildClient.usAutocompletePro>;
export type SmartyUsAutocompleteLookupT = InstanceType<typeof SmartySDK.usAutocompletePro.Lookup>;
export type SmartyUsAutocompleteSuggestionT = InstanceType<typeof SmartySDK.usAutocompletePro.Suggestion>;

const createSmartyClientBuilder = (embeddedKey: string): InstanceType<typeof SmartySDK.core.ClientBuilder> => (
  new SmartySDK.core.ClientBuilder(
    new SmartySDK.core.SharedCredentials(embeddedKey),
  )
);

export const getSmartyUsAutocompleteClient = (embeddedKey?: string): SmartyUsAutocompleteClientT | undefined => (
  embeddedKey
    ? createSmartyClientBuilder(embeddedKey).buildUsAutocompleteProClient()
    : undefined
);

export const buildSmartyAutocompleteSearch = ({ street }: SmartyAutocompleteInputT): string => street.trim();

export const createSmartyUsAutocompleteLookup = (
  search: string,
  preferredState?: string,
): SmartyUsAutocompleteLookupT => {
  const lookup = new SmartySDK.usAutocompletePro.Lookup(search);

  lookup.maxResults = 5;

  if (preferredState) {
    lookup.preferStates = [preferredState];
  }

  return lookup;
};
